export default "__VITE_ASSET__BRHLe8XM__"